/*
 * Tile
 * ==========
 *
 * Logic for board of one tile. Actually there is not much logic, mostly stores data for particular tile.
 * Logic is usually in propriate modules.
 */

export default class Tile {

  constructor (game, symbol, col, row) {
    this.game = game;

    this.col = col;
    this.row = row;

    this.symbol = symbol;

    this.view = game.make.group();

    this.tileBg = PARAMS.makeSprite(game, 0, 0, 'gameElements', 'tileFront.png');
    this.view.add(this.tileBg);
    // this.tileBg.alpha = 0

    this.selectBg = PARAMS.makeSprite(game, 0, 0, 'gameElements', 'tileSelectedCorrect.png');
    this.selectBg.alpha = 0;
    this.view.add(this.selectBg);

    this.selectBg2 = PARAMS.makeSprite(game, -1 * PARAMS.scaleFactor, -2 * PARAMS.scaleFactor, 'flashAnims', 'lastTileAnimation/0000');
    this.selectBg2.alpha = 0;
    this.view.add(this.selectBg2);

    var frames = window.Phaser.Animation.generateFrameNames('lastTileAnimation/', 0, 20, '', 4);

    this.selectBg2.animations.add('blink', frames, 18, true);

    this.letter = PARAMS.makeSprite(game, 0, 0, 'gameElements', symbol.toUpperCase() + '.png');
    this.view.add(this.letter);

    this.view.x = col * 47 * PARAMS.scaleFactor;
    this.view.y = row * 47 * PARAMS.scaleFactor;

    this.alive = true;
    this.selected = false
  }

  select () {
    this.selected = true
  }

  unselect () {
    this.selected = false;
    this.selectBg.alpha = 0;
    this.selectBg2.alpha = 0;
    this.selectBg2.animations.stop()
  }

  canBeSelected () {
    var xOnPlace = this.view.x === this.col * 47 * PARAMS.scaleFactor;
    var yOnPlace = this.view.y === this.row * 47 * PARAMS.scaleFactor;

    return this.alive && xOnPlace && yOnPlace
  }

  updateView (isCorrect, isLast, isPowerup) {
    this.selectBg.alpha = 1;

    var textureName = 'tile';
    if (isLast) textureName += 'Last';
    textureName += 'Selected';
    if (isCorrect) textureName += 'Correct';
    else textureName += 'Wrong';

    if (isPowerup && isLast) textureName = 'bombSelectedLast';
    if (isPowerup && !isLast) textureName = 'bombSelected';

    if (isCorrect && isLast && !isPowerup) {
      this.selectBg.alpha = 0;
      this.selectBg2.alpha = 1;
      this.selectBg2.play('blink')
    } else {
      this.selectBg.frameName = textureName + '.png';
      this.selectBg2.animations.stop();
      this.selectBg.alpha = 1;
      this.selectBg2.alpha = 0
    }

    this.selectBg.updateTransform()
  }

  isSelected () {
    return this.selected
  }

  isWithinDistanceLimit (pointer) {
    var localPos = this.view.toLocal(pointer);

    localPos.x -= 47 / 2 * PARAMS.scaleFactor;
    localPos.y -= 47 / 2 * PARAMS.scaleFactor;

    var dist = Phaser.Math.distance(0, 0, localPos.x, localPos.y) < 20 * PARAMS.scaleFactor;
    var line1 = localPos.y < localPos.x + 30 * PARAMS.scaleFactor;
    var line2 = localPos.y < -localPos.x + 30 * PARAMS.scaleFactor;
    var line3 = localPos.y > localPos.x - 30 * PARAMS.scaleFactor;
    var line4 = localPos.y > -localPos.x - 30 * PARAMS.scaleFactor;

    if (line1 && line2 && line3 && line4) return true;

    return false
  }

  explode () {
    this.alive = false;
    this.view.alpha = 0;
    this.view.destroy()
  }

}
